import React, { Component } from "react";
import { RangeInput } from "@appbaseio/reactivesearch";
import RangeFilterWithSelect from "./../../components/RangeFilterWithSelect";

class DiamondCaratWeight extends Component {
  constructor(props) {
    super(props);
    this.handleSelected = this.handleSelected.bind(this);
  }

  handleSelected(value) {
    // console.log("value : ", value);
    if (value.start === 0 && value.end === 100) {
      // console.log("firsttime load");
      return;
    } else {
      // console.log("Inside Handle Selected");
      this.props.showSelectedResults(true);
    }
  }

  render() {
    return (
      <div className="diamond-range form-field-wrap">
        <RangeInput
          className="diamond-con-range-input"
          innerClass={{
            "slider-container": "diamond-slider-container",
            "input-container": "diamond-input-container",
          }}
          title="Dia Weight"
          componentId="DiamondCaratWeight"
          showSlider={false}
          dataField={this.props.data}
          range={{
            start: 0,
            end: 100,
          }}
          customQuery={function(value, props) {
            if (value[0] === 0 && value[1] === 100) {
              return {
                query: {
                  match_all: {},
                },
              };
            } else {
              return {
                query: {
                  range: {
                    DiamondCaratWeight: {
                      gte: value[0],
                      lte: value[1],
                      boost: 2,
                    },
                  },
                },
              };
            }
          }}
          rangeLabels={{
            start: "$",
            end: "$",
          }}
          onValueChange={(value) => this.handleSelected(value)}
        />
      </div>
    );
  }
}
export default RangeFilterWithSelect(DiamondCaratWeight);
